import { SET_SBS } from "../constant";

const SBSReducer = (state = {}, action) => {
    switch (action.type) {
        case SET_SBS:
            return {
                ...state,
                data: action.data
            }
        default:
            return state
    }
}

export default SBSReducer